import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import defaultProfile from "../../../assets/Default_pfp.svg.png";
import { useNavigate } from "react-router-dom";

const AppointmentLetter = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      if (!token) {
        toast.error("No authentication token found");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const usersRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/establishment/active-users`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUsers(usersRes?.data?.activeUsers || []);
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load appointment letter data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  const filteredUsers = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return users;
    return users.filter((u) => (u?.full_Name || "").toLowerCase().includes(normalized));
  }, [users, query]);

  if (loading) {
    return <div className="text-center mt-4">Loading...</div>;
  }

  return (
    <div className="container-fluid py-3 py-md-4">
      <div className="row mb-3">
        <div className="col-12">
          <h1 className="text-center text-primary fw-bold mb-0">Appointment Letter</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-12 col-md-6 mx-auto">
          <input
            type="text"
            className="form-control"
            placeholder="Search by user name..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center">Profile</th>
                  <th>Employee ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Contact</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user._id} className="align-middle">
                    <td className="text-center">
                      <img
                        src={defaultProfile}
                        alt="Profile"
                        className="rounded-circle"
                        style={{ width: "40px", height: "40px", objectFit: "cover" }}
                      />
                    </td>
                    <td>{user?.employeeId || "N/A"}</td>
                    <td>{user?.full_Name || "N/A"}</td>
                    <td>{user?.email || "N/A"}</td>
                    <td>{user?.contact || "N/A"}</td>
                    <td className="text-center">
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() =>
                          navigate(`/establisment_dashboard/appointment-letter/${user._id}`, {
                            state: { user },
                          })
                        }
                      >
                        Show Appointment Letter
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredUsers.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center py-4 text-muted">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentLetter;
